<template>
    <div class="console">
        <div class="hello">
            <div class="l">
                <img src="https://i.gtimg.cn/club/item/face/img/2/16022_100.gif" alt="">
            </div>
            <div class="r">
                <div class="t">您好{{name}}！欢迎登录财务系统。</div>
                <div class="b">最近更新：1、新增车险公估、意健险、资产评估、快赔(江门)模块。</div>
            </div>
        </div>

        <div class="condition" style="margin-top:20px">
            <div class="condition-l">
                <div class="item">
                    <div class="label">发票号:</div>
                    <el-input v-model="conditionData.InvoiceNo" size="small" placeholder="请输入"></el-input>
                </div>
                
            <!-- </div>
            <div class="condition-r"> -->
                <el-date-picker
                    v-model="exportDate"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="margin:0 10px"
                    size="small">
                </el-date-picker>
                <el-select v-model="exportData.financeState" multiple size="small" placeholder="请选择财务状态" style="margin:0 10px">
                    <el-option
                    v-for="item in financeStateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                    <el-upload
                        :action="uploadUrl"
                        Multiple
                        :show-file-list="false"
                        :http-request="statisticsBatchUpTreasurer"
                         style="margin:0 10px"
                        >
                        <!-- <el-button type="success" size="small">批量修改</el-button> -->
                    </el-upload>
                    <el-button type="primary" size="small" icon="el-icon-upload" @click="exportExcel()">批量导出</el-button>
                </div>
            </div>
        </div>

        <div style="margin-top:20px">
            <el-date-picker
                v-model="searchDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small">
            </el-date-picker>
            <el-button type="primary" size="small" @click="dataSheet()">查询</el-button>
        </div>
        <el-row>
            <el-col :lg="12" :md="24" :sm="24">
                <div class="echart">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            案件量
                        </div>
                        <el-tag type="success">
                            日
                        </el-tag>
                    </div>
                    <div class="content" ref="authorization" id="visit"></div>
                </div>
            </el-col>

            <el-col :lg="12" :md="24" :sm="24">
                <div class="table" style="margin-left:10px;margin-top:20px">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            数据量
                        </div>
                    </div>
                    <div class="content">
                        <el-table
                            :data="tableData"
                            :header-cell-style="tableHeaderColor"
                            border
                            style="width: 100%;"
                            >
                            <el-table-column
                            prop="name"
                            label="案件类型"
                            align="center"
                            :show-overflow-tooltip="true"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="businessSys"
                            label="业务系统案件数量"
                            align="center"
                            :show-overflow-tooltip="true"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="financeSys"
                            label="财务中台案件数量"
                            align="center"
                            :show-overflow-tooltip="true"
                            sortable
                            >
                            </el-table-column>

                            <el-table-column
                            prop=""
                            label="操作"
                            align="center"
                            >
                                <!-- <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-edit" size="mini" @click="handleDate(scope.row)">数据修正</el-button>
                                </template> -->
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-col>
        </el-row>


        <el-tabs v-model="activeTab" @tab-click="handleClick" class="tabs" style="background:#FFFFFF;overflow-y: scroll;">
            <el-tab-pane :label="(organization=='分公司'?'总计':organization)+'应收款'">
                <div class="table">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            {{organization=='分公司'?'总计':organization}}应收款
                        </div>
                    </div>
                    <div class="content2">
                        <el-table
                            :data="tableData2"
                            :header-cell-style="tableHeaderColor"
                            border
                            style="width: 100%;">
                            <el-table-column
                            prop="name"
                            label="案件类型"
                            align="center"
                            :show-overflow-tooltip="true"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="wSCWKP"
                            label="未完成未开票"
                            align="center"
                            :show-overflow-tooltip="true"
                            >
                            </el-table-column>
                            
                            <el-table-column
                            prop="hKWC"
                            label="已完成未开票"
                            align="center"
                            :show-overflow-tooltip="true"
                            sortable
                            >
                            </el-table-column>
                            
                            <el-table-column
                            prop="yKPWHK"
                            label="已开票未回款"
                            align="center"
                            :show-overflow-tooltip="true"
                            sortable
                            >
                            </el-table-column>
                            

                            <el-table-column
                            prop="sun"
                            label="总计"
                            align="center"
                            :show-overflow-tooltip="true"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="wSCWKPMub"
                            label="未完成未开票数量"
                            align="center"
                            :show-overflow-tooltip="true"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="hKWCMub"
                            label="已完成未开票数量"
                            align="center"
                            :show-overflow-tooltip="true"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="yKPWHKMub"
                            label="已开票未回款数量"
                            align="center"
                            :show-overflow-tooltip="true"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="sunCaseMub"
                            label="总计数量"
                            align="center"
                            :show-overflow-tooltip="true"
                            sortable
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="'分公司应收款'" v-if="organization=='总公司'">
                <div class="table">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            分公司应收款
                        </div>
                    </div>
                    <div class="content3">
                        <el-table
                            v-loading="loading3"
                            :data="tableData3"
                            :header-cell-style="tableHeaderColor"
                            border
                            style="width: 100%;"
                            >
                            <el-table-column
                            prop="companyM"
                            label="公司名称"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="wwcCaseMoney"
                            label="未完成未开票"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <el-popover
                                placement="right"
                                width="400"
                                trigger="click"
                                @show="showTable(scope.row,1)">
                                <el-table :data="gridData" :header-cell-style="tableHeaderColor" border>
                                    <el-table-column property="name" label="案件类型"></el-table-column>
                                    <el-table-column property="data" label="未完成未开票"></el-table-column>
                                </el-table>
                                <span slot="reference">
                                    {{scope.row.wwcCaseMoney}}
                                    <i class="el-icon-plus icolor"></i>
                                </span>
                                </el-popover>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="ywcCaseMoney"
                            label="已完成未开票"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <el-popover
                                placement="right"
                                width="400"
                                trigger="click"
                                @show="showTable(scope.row,2)">
                                <el-table :data="gridData" :header-cell-style="tableHeaderColor" border>
                                    <el-table-column property="name" label="案件类型"></el-table-column>
                                    <el-table-column property="data" label="已完成未开票"></el-table-column>
                                </el-table>
                                <span slot="reference">
                                    {{scope.row.ywcCaseMoney}}
                                    <i class="el-icon-plus icolor"></i>
                                </span>
                                </el-popover>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="ykpnoCaseMoney"
                            label="已开票未回款"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <el-popover
                                placement="right"
                                width="400"
                                trigger="click"
                                @show="showTable(scope.row,3)">
                                <el-table :data="gridData" :header-cell-style="tableHeaderColor" border>
                                    <el-table-column prop="name" label="案件类型"></el-table-column>
                                    <el-table-column prop="data" label="已开票未回款"></el-table-column>
                                </el-table>
                                <span slot="reference">
                                    {{scope.row.ykpnoCaseMoney}}
                                    <i class="el-icon-plus icolor"></i>
                                </span>
                                </el-popover>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="countMoney"
                            label="合计"
                            align="center"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>

            <el-tab-pane label="车险事业部应收款" v-if="userType=='1'||userType=='0'">
                <div class="table">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            车险事业部应收款
                        </div>
                    </div>
                    <div class="content3">
                        <el-table
                            v-loading="loading3"
                            :data="businessData1"
                            :header-cell-style="tableHeaderColor"
                            border
                            style="width: 100%;"
                            >
                            <el-table-column
                            prop="companyM"
                            label="公司名称"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="wwcCaseMoney"
                            label="未完成未开票"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="ywcCaseMoney"
                            label="已完成未开票"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="ykpnoCaseMoney"
                            label="已开票未回款"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="countMoney"
                            label="合计"
                            align="center"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="意健险事业部应收款" v-if="userType=='2'||userType=='0'">
                <div class="table">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            意健险事业部应收款
                        </div>
                    </div>
                    <div class="content3">
                        <el-table
                            v-loading="loading3"
                            :data="businessData2"
                            :header-cell-style="tableHeaderColor"
                            border
                            style="width: 100%;"
                            >
                            <el-table-column
                            prop="companyM"
                            label="公司名称"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="wwcCaseMoney"
                            label="未完成未开票"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="ywcCaseMoney"
                            label="已完成未开票"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="ykpnoCaseMoney"
                            label="已开票未回款"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="countMoney"
                            label="合计"
                            align="center"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="资产评估事业部应收款" v-if="userType=='3'||userType=='0'">
                <div class="table">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            资产评估事业部应收款
                        </div>
                    </div>
                    <div class="content3">
                        <el-table
                            v-loading="loading3"
                            :data="businessData3"
                            :header-cell-style="tableHeaderColor"
                            border
                            style="width: 100%;"
                            >
                            <el-table-column
                            prop="companyM"
                            label="公司名称"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="wwcCaseMoney"
                            label="未完成未开票"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="ywcCaseMoney"
                            label="已完成未开票"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="ykpnoCaseMoney"
                            label="已开票未回款"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="countMoney"
                            label="合计"
                            align="center"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="快赔事业部应收款" v-if="userType=='4'||userType=='0'">
                <div class="table">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            快赔事业部应收款
                        </div>
                    </div>
                    <div class="content3">
                        <el-table
                            v-loading="loading3"
                            :data="businessData4"
                            :header-cell-style="tableHeaderColor"
                            border
                            style="width: 100%;"
                            >
                            <el-table-column
                            prop="companyM"
                            label="公司名称"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="wwcCaseMoney"
                            label="未完成未开票"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="ywcCaseMoney"
                            label="已完成未开票"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="ykpnoCaseMoney"
                            label="已开票未回款"
                            align="center"
                            >
                            
                            </el-table-column>
                            <el-table-column
                            prop="countMoney"
                            label="合计"
                            align="center"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

        
            

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditDialog" :title="'发票号:'+conditionData.InvoiceNo+'——'+queryStandStr" width="1200px">
            <div class="dialog dialog-a">
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        立项类型:
                    </div>
                    <div class="item-input">
                        <el-select v-model="editData.standType" size="small" placeholder="请选择" disabled>
                            <el-option
                            v-for="item in standTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        立项名称:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.name" size="small" placeholder="" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        上传缩略图:
                    </div>
                    <div class="item-input">
                        <!-- <el-upload
                            :action="uploadUrl"
                            Multiple
                            :show-file-list="false"
                            :http-request="uploadimgUrl"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small">点击上传</el-button>
                        </el-upload> -->
                        <div class="item-imgs">
                            <div style="width: 100px; height: 100px" class="item-img" v-for="(item,index) in imgUrlList" :key="index" v-if="item">
                                <!-- <div class="icon" @click="deleteImg(index)">
                                    <i class="el-icon-delete"></i>
                                </div> -->
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="item"
                                :preview-src-list="[item]"
                                fit="cover"></el-image>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.invoiceNo" size="small" placeholder="" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票编码:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.invoiceCode" size="small" placeholder="" disabled></el-input>
                    </div>
                </div>

                
                <div class="item">
                    <div class="label">
                        发票金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.invoicePrice" size="small" type="number" placeholder="" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        状态:
                    </div>
                    <div class="item-input">
                        <el-select v-model="editData.financeState" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in standTermStatus"
                            :key="item.label"
                            :label="item.label"
                            :value="item.label">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        实际收金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.actualPrice" size="small" type="number" placeholder="" @focus="arrivalMoneyChange"></el-input>
                    </div>
                </div>
                 <div class="item">
                    <div class="label">
                        到账时间:
                    </div>
                    <div class="item-input">
                        <el-date-picker
                        v-model="editData.arrivalTime"
                        size="small"
                        type="datetime"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        到账金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.arrivalMoney" size="small" type="number" placeholder="" @input="isInputChange"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        公司:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.company" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        开票时间:
                    </div>
                    <div class="item-input"  disabled>
                        <el-date-picker
                        v-model="editData.invoicingTime"
                        size="small"
                        type="datetime"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>

                
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        委托公司全称:
                    </div>
                    <div class="item-input">
                        <el-autocomplete
                            class="inline-input"
                            v-model="editData.companyCodeName"
                            :fetch-suggestions="querySearch"
                            placeholder=""
                            :trigger-on-focus="false"   
                            @select="handleSelect"
                            @keyup.enter.native="search"
                            size="small"
                             disabled
                        >
                            <template slot-scope="{ item }">
                                <div class="name">{{ item.subjectName}}</div>
                            </template>
                        </el-autocomplete>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        快递单号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.expressOrderNumber" size="small" placeholder=""  disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        收件人:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.receivingPeople" size="small" placeholder=""  disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        联系电话:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.telephone" size="small" placeholder=""  disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        开票内容:
                    </div>
                    <div class="item-textarea" style="width:320px">
                        <el-input v-model="editData.billingContent" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item item-ta">
                    <div class="label">
                        备注:
                    </div>
                    <div class="item-textarea">
                        <el-input v-model="remarks" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <el-table
                    :data="remarksTable"
                    border
                    style="width: 510px">
                        <el-table-column
                        prop=""
                        label="备注记录"
                        >
                        <template slot-scope="scope">
                            <span>{{scope.row}}</span>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="edit()">确认提交</el-button>
                    <!-- <el-button type="primary" icon="el-icon-upload" size="mini" @click="pushKinDie(editData)" v-if="!editData.isPushKinDie">复推</el-button> -->
                </div>
            </div>
        </el-dialog>
        <!-- <div class="sect">
            <div class="item">
                <div class="title">
                    <div class="l">
                        <i class="el-icon-data-line"></i>
                        访问量
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS,accAdd,accSubtract,parseTimeD} from '../../../utils/index'
import {standTermStatus,standTypeList} from '../../../assets/selectList/assetsSelectList'
export default {
    name: 'console',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            standTypeList:standTypeList,
            searchDate:[],
            uploadUrl:'',
            conditionData:{
                InvoiceNo:"",
            },
            isEditDialog:false,
            editData:{},
            imgUrlList:[],
            remarksTable:[],
            standTermStatus:standTermStatus,
            queryStandStr:'',
            isInput:false,

            visitChart:null,
            authorizationChart:null,
            name:localStorage.getItem('name'),
            tableData:[],
            tableData2:[],
            tableData3:[],
            queryStand:null,
            sheetQuery:{
            //    startTime:'',
            //    endTime:'',
            },
            sysData:{},

            activeTab:0,
            activeLabel:'',

            loading3:false,
            gridData:[],
            organization:localStorage.getItem('organization'),
            exportData:{
                financeState:[]
            },
            exportDate:[],
            // 车险
            financeStateList: [
                {
                    value: '已开票未回款',
                    label: '已开票未回款',
                },{
                    value: '已开票部分回款',
                    label: '已开票部分回款',
                },{
                    value: '回款完成',
                    label: '回款完成',
                },{
                    value: '已回款未开票',
                    label: '已回款未开票',
                },{
                    value: '红冲',
                    label: '红冲',
                },{
                    value: '作废',
                    label: '作废',
                },{
                    value: '其他',
                    label: '其他',
                },
            ],
            businessData1:[],
            businessData2:[],
            businessData3:[],
            businessData4:[],
            userType:localStorage.getItem('userType'),
        }
    },
    created(){
        

    },
    mounted(){
        this.dataSheet();
        let _this = this;
        window.onresize = function(){
            _this.initAuthorizationChart(_this.sysData);
        }
    },
    methods:{
        async getBusinessData1(){
            let startTime = '';
            let endTime = '';
            if(this.searchDate&&this.searchDate.length>0){
                startTime = this.searchDate[0];
                endTime = this.searchDate[1];
            }
            this.loading3 = true;
            let res  = await api.getCPAllData({
                businessModule:10,
                startTime:startTime,
                endTime:endTime
            });
            
            this.loading3 = false;
            this.businessData1 = res.data.data.resCounts;
        },
        async getBusinessData2(){
            let startTime = '';
            let endTime = '';
            if(this.searchDate&&this.searchDate.length>0){
                startTime = this.searchDate[0];
                endTime = this.searchDate[1];
            }
            this.loading3 = true;
            let res  = await api.getCPAllData({
                businessModule:11,
                startTime:startTime,
                endTime:endTime
            });
            this.loading3 = false;
            this.businessData2 = res.data.data.resCounts; 
        },
        async getBusinessData3(){
            let startTime = '';
            let endTime = '';
            if(this.searchDate&&this.searchDate.length>0){
                startTime = this.searchDate[0];
                endTime = this.searchDate[1];
            }
            this.loading3 = true;
            let res  = await api.getCPAllData({
                businessModule:4,
                startTime:startTime,
                endTime:endTime
            });
            this.loading3 = false;
            this.businessData3 = res.data.data.resCounts; 
        },
        async getBusinessData4(){
            let startTime = '';
            let endTime = '';
            if(this.searchDate&&this.searchDate.length>0){
                startTime = this.searchDate[0];
                endTime = this.searchDate[1];
            }
            this.loading3 = true;
            let res  = await api.getCPAllData({
                businessModule:2,
                startTime:startTime,
                endTime:endTime
            });
            this.loading3 = false;
            this.businessData4 = res.data.data.resCounts; 
        },
        async pushKinDie(row){
            let res = await api.pushKinDie({invoiceNo:row.invoiceNo});
            if(res.data.data.data){
                this.$message({
                    type: 'success',
                    message: '复推成功!'
                });
                this.loadingData();
            }else{
                if(!res.data.data){
                    return;
                }
                this.$confirm(res.data.data.msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                }).catch(() => {
                });
            }
        },
        async exportExcel(){
            if(this.exportDate&&this.exportDate.length>0){
                this.exportData.startTime = this.exportDate[0];
                this.exportData.endTime = this.exportDate[1];
            }else{
                this.exportData.startTime = null;
                this.exportData.endTime = null;
            }
            let res = await api.statisticsExportStand(this.exportData);
            
        },
        showTable(row,type){
            this.statisticsCompanyData(row,type);
        },
        async statisticsCompanyData(row,type){
            let startTime = null;
            let endTime = null;
            if(this.searchDate&&this.searchDate.length>0){
                startTime = this.searchDate[0];
                endTime = this.searchDate[1];
            }
            let res = await api.statisticsCompanyData({
                company: row.companyM,
                statisticsEunm: type,
                startTime: startTime,
                endTime: endTime
            });
            let bS = res.data.data.businessSysMub;
            this.gridData = [];
            this.gridData.push({name:'车险公估',data:bS.carCase})
            this.gridData.push({name:'车险公估(人员派驻)',data:bS.carOutCase})
            this.gridData.push({name:'意健险',data:bS.accCase})
            this.gridData.push({name:'意健险(人员派驻)',data:bS.claCase})
            this.gridData.push({name:'资产评估',data:bS.assCase})
            this.gridData.push({name:'资产评估/财产险人员派驻',data:bS.assCaseout})
            if(row.companyM.indexOf('江门') != -1){
                this.gridData.push({name:'快赔(江门)',data:bS.fasCase})
            }
            console.log(this.gridData);
        },
        handleClick(e){
            this.activeLabel = e.label;
            if(e.index==0){
                this.plateSheet();
            }else if(e.index==1){
                this.loadingStatistics();
            }else if(e.label=="车险事业部应收款"){
                this.getBusinessData1();
            }else if(e.label=="意健险事业部应收款"){
                this.getBusinessData2();
            }else if(e.label=="资产评估事业部应收款"){
                this.getBusinessData3();
            }else if(e.label=="快赔事业部应收款"){
                this.getBusinessData4();
            }
            // else{
            //     this.loadingStatistics();
            // }else{
            //     this.loadingStatistics();
            // }else{
            //     this.loadingStatistics();
            // }else{
            //     this.loadingStatistics();
            // }
        },
        async handleDate(data){
            console.log(data);
            // if(data.diversity.length==0){
            //     this.$message({
            //         type: 'warning',
            //         message: '案件数量正确，无须修改!'
            //     });
            //     return;
            // }
            let type = 1;
            if(data.name == '车险人伤'){
                type = 1;
            }else if(data.name == '车险公估(人员派驻)'){
                type = 2;
            }else if(data.name == '意健险'){
                type = 4;
            }else if(data.name == '意健险(人员派驻)'){
                type = 5;
            }else if(data.name == '资产评估'){
                type = 6;
            }else if(data.name == '快赔(江门)'){
                type = 7;
            }else if(data.name == '财产险'){
                type = 8;
            }
            let res = await api.handleDate({
                dates:data.diversity,
                queryStand:type,
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.dataSheet();
            }
        },
        async dataSheet(){
            if(this.searchDate&&this.searchDate.length>0){
                this.sheetQuery.startTime = this.searchDate[0];
                this.sheetQuery.endTime = this.searchDate[1];
            }else{
                this.sheetQuery = {}
            }
            console.log(this.sheetQuery);
            let res = await api.dataSheet(this.sheetQuery);
            if(res.data.code == '200'){
                this.handleClick({index:this.activeTab,label:this.activeLabel});
            }
            let rData = res.data.data;
            this.sysData = rData;
            this.tableData=[];
            this.tableData.push({name:'车险公估',businessSys:rData.businessSys.carCase,financeSys:rData.financeSys.carCase ,diversity:rData.diversity.carCase})
            this.tableData.push({name:'车险公估(人员派驻)',businessSys:rData.businessSys.carOutCase,financeSys:rData.financeSys.carOutCase,diversity:rData.diversity.carOutCase})
            this.tableData.push({name:'意健险',businessSys:rData.businessSys.accCase,financeSys:rData.financeSys.accCase,diversity:rData.diversity.accCase})
            this.tableData.push({name:'意健险(人员派驻)',businessSys:rData.businessSys.claCase,financeSys:rData.financeSys.claCase,diversity:rData.diversity.claCase})
            this.tableData.push({name:'资产评估',businessSys:rData.businessSys.assCase,financeSys:rData.financeSys.assCase,diversity:rData.diversity.assCase})
            this.tableData.push({name:'财产险',businessSys:rData.businessSys.assCase_ccx,financeSys:rData.financeSys.assCase_ccx,diversity:rData.diversity.assCase_ccx})
            this.tableData.push({name:'快赔(江门)',businessSys:rData.businessSys.fasCase,financeSys:rData.financeSys.fasCase,diversity:rData.diversity.fasCase})
            
            this.initAuthorizationChart(res.data.data);
        },
        async plateSheet(){
   
            this.sheetQuery.company = localStorage.getItem('organization');
            this.sheetQuery.StartTime =  this.searchDate[0];
            this.sheetQuery.EndTime =  this.searchDate[1];
            let res = await api.plateSheet(this.sheetQuery);
            console.log(res);
            let rData = res.data.data;
            this.tableData2=[];
            this.tableData2.push({name:'车险公估',wSCWKP:rData.wSCWKP.carCase,wSCWKPMub:rData.wSCWKP.carCaseMub,yKPWHK:rData.yKPWHK.carCase ,yKPWHKMub:rData.yKPWHK.carCaseMub ,hKWC:rData.hKWC.carCase,hKWCMub:rData.hKWC.carCaseMub,sun:rData.sunCase.carCase,sunCaseMub:rData.sunCase.carCaseMub})
            this.tableData2.push({name:'车险公估(人员派驻)',wSCWKP:rData.wSCWKP.carOutCase,wSCWKPMub:rData.wSCWKP.carOutCaseMub,yKPWHK:rData.yKPWHK.carOutCase ,yKPWHKMub:rData.yKPWHK.carOutCaseMub ,hKWC:rData.hKWC.carOutCase,hKWCMub:rData.hKWC.carOutCaseMub,sun:rData.sunCase.carOutCase,sunCaseMub:rData.sunCase.carOutCaseMub})
            this.tableData2.push({name:'意健险',wSCWKP:rData.wSCWKP.accCase,wSCWKPMub:rData.wSCWKP.accCaseMub,yKPWHK:rData.yKPWHK.accCase ,yKPWHKMub:rData.yKPWHK.accCaseMub ,hKWC:rData.hKWC.accCase,hKWCMub:rData.hKWC.accCaseMub,sun:rData.sunCase.accCase,sunCaseMub:rData.sunCase.accCaseMub})
            this.tableData2.push({name:'意健险(人员派驻)',wSCWKP:rData.wSCWKP.claCase,wSCWKPMub:rData.wSCWKP.claCaseMub,yKPWHK:rData.yKPWHK.claCase ,yKPWHKMub:rData.yKPWHK.claCaseMub ,hKWC:rData.hKWC.claCase,hKWCMub:rData.hKWC.claCaseMub,sun:rData.sunCase.claCase,sunCaseMub:rData.sunCase.claCaseMub})
            this.tableData2.push({name:'资产评估/财产险',wSCWKP:rData.wSCWKP.assCase,wSCWKPMub:rData.wSCWKP.assCaseMub,yKPWHK:rData.yKPWHK.assCase ,yKPWHKMub:rData.yKPWHK.assCaseMub ,hKWC:rData.hKWC.assCase,hKWCMub:rData.hKWC.assCaseMub,sun:rData.sunCase.assCase,sunCaseMub:rData.sunCase.assCaseMub})
            // this.tableData2.push({name:'财产险',wSCWKP:rData.wSCWKP.assCase_ccx,wSCWKPMub:rData.wSCWKP.assCaseMub_ccx,yKPWHK:rData.yKPWHK.assCase_ccx ,yKPWHKMub:rData.yKPWHK.assCaseMub_ccx ,hKWC:rData.hKWC.assCase_ccx,hKWCMub:rData.hKWC.assCaseMub_ccx,sun:rData.sunCase.assCase_ccx,sunCaseMub:rData.sunCase.assCaseMub_ccx})
            
            
            //资产评估人员派驻

            this.tableData2.push({name:'资产评估/财产险人员派驻',wSCWKP:rData.wSCWKP.assCaseout,wSCWKPMub:rData.wSCWKP.assCaseMubOut,yKPWHK:rData.yKPWHK.assCaseOut ,yKPWHKMub:rData.yKPWHK.assCaseMubOut ,hKWC:rData.hKWC.assCaseOut,hKWCMub:rData.hKWC.assCaseMubOut,sun:rData.sunCase.assCaseOut,sunCaseMub:rData.sunCase.assCaseMubOut})
            this.tableData2.push({name:'快赔(江门)',wSCWKP:rData.wSCWKP.fasCase,wSCWKPMub:rData.wSCWKP.fasCaseMub,yKPWHK:rData.yKPWHK.fasCase ,yKPWHKMub:rData.yKPWHK.fasCaseMub ,hKWC:rData.hKWC.fasCase,hKWCMub:rData.hKWC.fasCaseMub,sun:rData.sunCase.fasCase,sunCaseMub:rData.sunCase.fasCaseMub})
            this.tableData2.push({name:'总计',wSCWKP:rData.wSCWKP.sun,wSCWKPMub:rData.wSCWKP.sunCaseMub,yKPWHK:rData.yKPWHK.sun ,yKPWHKMub:rData.yKPWHK.sunCaseMub ,hKWC:rData.hKWC.sun,hKWCMub:rData.hKWC.sunCaseMub ,sun:rData.sunCase.sun,sunCaseMub:rData.sunCase.sunCaseMub})
        },

        async loadingStatistics(){
            let startTime = '';
            let endTime = '';
            if(this.searchDate&&this.searchDate.length>0){
                startTime = this.searchDate[0];
                endTime = this.searchDate[1];
            }
            this.loading3 = true;
            let res  = await api.getCPAllData({
                businessModule:7,
                startTime:startTime,
                endTime:endTime
            });
            this.loading3 = false;
            this.tableData3 = res.data.data.resCounts;
        },

        async statisticsBatchUpTreasurer(file){
            let res = await api.statisticsBatchUpTreasurer(file.file);
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                this.loadingData();
            }
        },
         
        async selectData(){
            let res = await api.statisticsTreasurer(this.conditionData);
            console.log(res);
            if(res.data.code == '200'){
                if(!res.data.data.args){
                    this.$message({
                        type: 'warning',
                        message: '查无信息!'
                    });
                    return;
                }
                this.isEditDialog = true;
                
                this.editData = res.data.data.args?res.data.data.args:{};
                this.queryStand = res.data.data.queryStand;

                if(this.queryStand == 1){
                    this.queryStandStr = '车险人伤'
                }else if(this.queryStand == 2){
                    this.queryStandStr = '车险公估(人员派驻)'
                }else if(this.queryStand == 4){
                    this.queryStandStr = '意健险'
                }else if(this.queryStand == 5){
                    this.queryStandStr = '意健险(人员派驻)'
                }else if(this.queryStand == 6){
                    this.queryStandStr = '资产评估'
                }else if(this.queryStand == 7){
                    this.queryStandStr = '快赔(江门)'
                }
                else if(this.queryStand == 9){
                    this.queryStandStr = '资产评估/财产险人员派驻'
                }

                if(this.editData&&this.editData.imgUrl){
                    this.imgUrlList = this.editData.imgUrl.split(',');
                }else{
                    this.imgUrlList = [];
                }
                if(this.editData&&this.editData.remarks){
                    this.remarksTable = this.editData.remarks.split('<remarksTable>');
                }else{
                    this.remarksTable = [];
                }
            }
        },
        async edit(){
            this.editData.projectPeople = localStorage.getItem("userName");
            this.editData.fileUp = this.editData.fileUp?this.editData.fileUp:'';
            if(this.editData.invoicePrice){
                this.editData.invoicePrice = parseFloat(this.editData.invoicePrice);
            }else{
                this.editData.invoicePrice = 0;
            }
            if(this.editData.arrivalMoney){
                this.editData.arrivalMoney = parseFloat(this.editData.arrivalMoney);
            }else{
                this.editData.arrivalMoney = 0;
            }
            if(this.editData.actualPrice){
                this.editData.actualPrice = parseFloat(this.editData.actualPrice);
            }else{
                this.editData.actualPrice = 0;
            }
            if(this.editData.total){
                this.editData.total = parseFloat(this.editData.total);
            }else{
                this.editData.total = 0;
            }

            
            this.editData.imgUrl=''
            for(let index in this.imgUrlList){
                if(index==0){
                    this.editData.imgUrl = this.imgUrlList[index]
                }else{
                    this.editData.imgUrl = this.editData.imgUrl+','+this.imgUrlList[index]
                }
            }
            for(let index in this.remarksTable){
                if(index==0){
                    this.editData.remarks = this.remarksTable[index]
                }else{
                    this.editData.remarks = this.editData.remarks + '<remarksTable>' + this.remarksTable[index]
                }
            }
            if(this.remarks&&this.remarks.length>0){
                if(this.editData.remarks){
                    this.editData.remarks = this.editData.remarks + '<remarksTable>' + this.remarks
                }else{
                    this.editData.remarks = this.remarks
                }
            }
            let res = await api.statisticsUpTreasurer({
                args:this.editData,
                queryStand:this.queryStand,
            });
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
                this.remarks = '',
                this.isEditDialog = false;
            }
        },



        
        initAuthorizationChart(data){
            let businessSys = data.businessSys;
            let financeSys = data.financeSys;
            let option = {
                legend: {
                    data: ['业务系统案件数量', '财务中台案件数量']
                },
                xAxis: {
                    type: 'category',
                    data: ['车险公估', '车险外派', '意健险', '意健险外派', '资产评估', '财产险', '快赔(江门)'],
                },
                yAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    type: 'value'
                },
                grid: {
                    top:'15% ',
                    bottom:'15% ',
                    left: '20% '
                },
                 tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                series: [{
                    name:'业务系统案件数量',
                    data: [businessSys.carCase, businessSys.carOutCase, businessSys.accCase, businessSys.claCase, businessSys.assCase,businessSys.assCase_ccx, businessSys.fasCase],
                    type: 'bar',
                    showBackground: true,
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#83bff6'},
                                {offset: 0.5, color: '#188df0'},
                                {offset: 1, color: '#188df0'}
                            ]
                        )
                    },
                },{
                    name:'财务中台案件数量',
                    data: [financeSys.carCase, financeSys.carOutCase, financeSys.accCase, financeSys.claCase, financeSys.assCase,financeSys.assCase_ccx, financeSys.fasCase],
                    type: 'bar',
                    showBackground: true,
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 1, color: '#13ce66'},
                                {offset: 0, color: '#58e7d6'}
                            ]
                        )
                    },
                }]
            };
            this.$nextTick(()=>{
                this.authorizationChart = this.$echarts.init(this.$refs.authorization);
                this.authorizationChart.clear();
                this.authorizationChart.setOption(option,true);
                this.authorizationChart.resize();
            })
            
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000000;'
            }
        },

        caseListDetail(row){
            console.log(row);
        },


        isInputChange(){
            console.log('isInputChange');
            this.isInput = true;
        },
        arrivalMoneyChange(){
            console.log('arrivalMoneyChange');
            if(!this.isInput){
                return;
            }
            this.editData.actualPrice = accAdd(this.editData.actualPrice,this.editData.arrivalMoney);
            this.isInput=false;
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .console{
        padding: 10px;
        /deep/.el-tabs__item{
            font-size: 15px;
            font-weight: bold;
        }
        .icolor{
            color:#409EFF
        }
        .condition{
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            color: #303133;
            display: flex;
            align-items: center;
            min-height: 105px;
            padding: 0 20px;
            transition: .3s;
            .item{
                display: flex;
                align-items: center;
                padding: 7px;
                .label{
                    min-width: 110px;
                }
            }
            .btns{
                display: flex;
                margin-left: 20px;
            }
            .condition-l{
                height: 105px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                flex: 1;
                // border-right: 1px solid #ebeef5;
            }
            .condition-r{
                height: 105px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                flex: 1;
                padding-left: 20px;
            }
        }
        .dialog{
            padding-top: 20px;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .item{
                
                font-size: 14px;
                padding:10px 150px;
                display: flex;
                align-items: center;
                justify-content: center;
                .label{
                    min-width: 110px;
                    margin-bottom: 5px;
                    span{
                        color:red
                    }
                }
                .item-input{
                    width: 300px;
                    display: flex;
                    align-items: center;
                }
                .item-imgs{
                    width: 400px;
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 10px;
                    .item-img{
                        position: relative;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        .icon{
                            right: 0;
                            top: 0;
                            position:absolute;
                            z-index: 100;
                            color: #ffffff;
                            background-color: #000000;
                            width: 18px;
                            height: 18px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                        }

                    }
                }
                /deep/.el-image{
                    margin-left: 10px;
                }
                .item-textarea{
                    width: 400px;
                }
            }
            
            .dialog-footer{
                width: 100%;
                display: flex;
                justify-content: center;
                .el-button{
                    margin-top: 20px;
                }
            }
            
        }
        .dialog-a{
            .item{
                font-size: 14px;
                padding:10px 50px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .item-ta{
                width:920px;
                .item-textarea{
                    width: 960px;
                }
            }
            
        }

        .hello{
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            color: #303133;
            display: flex;
            align-items: center;
            min-height: 105px;
            padding: 20px;
            transition: .3s;
            .l{
                width: 60px;
                height: 60px;
                margin-right: 20px;
                border-radius: 50%;
                img{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                }
            }
            .r{
                .t{
                    margin-bottom: 12px;
                    font-size: 20px;
                    font-weight: 700;
                    color: #3c4a54;
                }
                .b{
                    font-size: 14px;
                    color: #808695;
                }
            }
            
        }
        .hello:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
        .echart{
            // width: 300px;
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            overflow: hidden;
            color: #303133;
            transition: .3s;
            // min-height: 268px;
            margin-top: 20px;
            position: relative;
            // height: 315px;
            .title{
                font-size: 14px;
                line-height: 14px;
                padding: 0 20px;
                height: 44px;
                border-bottom: 1px solid #ebeef5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .r{
                    height: 24px;
                    padding: 0 8px;
                    line-height: 24px;
                    background-color: #e7faf0;
                    border-color: #d0f5e0;
                    color: #13ce66;
                }
                .z{
                    height: 24px;
                    padding: 0 8px;
                    line-height: 24px;
                    background-color: #fff8e6;
                    border-color: #fff1cc;
                    color: #ffba00;
                }
            }
            .content{
                height: 450px;
            }
            .bottom{
                width: 100%;
                position: absolute;
                height: 50px;
                bottom: 0;
                border-top: 1px solid #ebeef5;
                display: flex;
                align-items: center;
                font-size: 14px;
                padding-left: 20px;
            }
        }
        .echart:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
        .tabs{
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            overflow: hidden;
            color: #303133;
            transition: .3s;
            // min-height: 268px;
            margin-top: 10px;
            position: relative;
            padding: 0 10px;
        }
        .tabs:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
        .table{
            // width: 300px;
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            overflow: hidden;
            color: #303133;
            transition: .3s;
            min-height: 268px;
            // margin-top: 20px;
            /deep/.el-table th{
                padding: 7px 0;
            }
            .title{
                font-size: 14px;
                line-height: 14px;
                padding: 0 20px;
                height: 44px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #ebeef5;
            }
            .content{
                height: 420px;
                padding: 15px;
            }
            .content2{
                height: 450px;
                padding: 15px;
            }
            .content3{
                padding: 15px;
            }
        }
        .table:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
    }
</style>
